var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"like-wraper"},[_c('div',{staticClass:"animation",class:_vm.animation ? 'start' : '',on:{"click":_vm.like}}),_c('div',{staticClass:"like-count"},[_vm._v(_vm._s(_vm.totalCount))])])
}
var staticRenderFns = []

export { render, staticRenderFns }